import BaseServiceHttp from '../baseService'
class Leitores extends BaseServiceHttp {
  constructor(id) {
    const resource = 'leitores'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Leitores(id)
